<main>
    <svelte:component this={route}/>
</main>

<script>
    import Nav from "./navigation.svelte"
    import Navaid from 'navaid';
    import { onDestroy } from 'svelte';
    import { onMount } from 'svelte'

    let route, params={}, active;
    let uri = location.pathname;
    /*$: active = uri.split('/')[1] || '';*/

    console.log('OY');

    console.log(route)

    // onMount(() => {
    //     console.log("on Mount")
    //     run(import('../routes/cards_stack.svelte'));
    // })


    function run(thunk, obj) {

        console.log("Function run")
        const target = uri;

        console.log("target", target)

        thunk.then(m => {

            if (target !== uri) {

                return;
            }

            params = obj || {};

            if (m.preload) {


                m.preload({ params }).then(() => {

                    if (target !== uri) {

                        return;
                    }

                    route = m.default;
                    window.scrollTo(0, 0);
                    console.log(route)

                });

            } else {

                route = m.default;
                window.scrollTo(0, 0);
                console.log(route)

            }

        });

    }

    function track(obj) {

        uri = obj.state || obj.uri || location.pathname;
    }

    addEventListener('replacestate', track);
    addEventListener('pushstate', track);
    addEventListener('popstate', track);

    const router = Navaid('/')
        .on('/', () => run(import('../routes/cards_stack.svelte')))
        .on('/auth', () => run(import('../routes/auth.svelte')))
        .on('/liked', () => run(import('../routes/liked_list.svelte')))
        .on('/profile', () => run(import('../routes/profile.svelte')))
        .listen();

    onDestroy(router.unlisten);
</script>






<style>
    main {
        position: relative;
        height: 100%;
    }

</style>